import {ListItem} from '@github-ui/list-view/ListItem'
import {ListItemDescription} from '@github-ui/list-view/ListItemDescription'
import {ListItemDescriptionItem} from '@github-ui/list-view/ListItemDescriptionItem'
import {ListItemLeadingContent} from '@github-ui/list-view/ListItemLeadingContent'
import {ListItemLeadingVisual} from '@github-ui/list-view/ListItemLeadingVisual'
import {ListItemMainContent} from '@github-ui/list-view/ListItemMainContent'
import {ListItemMetadata} from '@github-ui/list-view/ListItemMetadata'
import {ListItemTitle} from '@github-ui/list-view/ListItemTitle'
import {SkeletonBox} from '@primer/react/experimental'

import styles from './PullsInboxSection.module.css'

export function PullsInboxChecksSkeleton() {
  return <SkeletonBox height="16px" width="40px" />
}

export function PullsInboxSectionSkeletonItem() {
  return (
    <ListItem
      metadataContainerClassName={styles.metadataContainer}
      title={
        <ListItemTitle value={<span className="sr-only">Loading</span>}>
          <SkeletonBox height="20px" width="60%" />
        </ListItemTitle>
      }
      metadata={[
        <ListItemMetadata key="status" className={styles.statusColumn}>
          <SkeletonBox height="16px" width="100px" />
        </ListItemMetadata>,
        <ListItemMetadata key="checks" className={styles.checksColumn}>
          <PullsInboxChecksSkeleton />
        </ListItemMetadata>,
        <ListItemMetadata key="comments" className={styles.commentsColumn}>
          <SkeletonBox height="16px" width="32px" />
        </ListItemMetadata>,
      ]}
    >
      <ListItemLeadingContent>
        <ListItemLeadingVisual>
          <SkeletonBox height="16px" width="16px" style={{borderRadius: 'var(--borderRadius-full)'}} />
        </ListItemLeadingVisual>
      </ListItemLeadingContent>
      <ListItemMainContent>
        <ListItemDescription className={styles.description}>
          <ListItemDescriptionItem>
            <SkeletonBox height="14px" width="40%" />
          </ListItemDescriptionItem>
        </ListItemDescription>
      </ListItemMainContent>
    </ListItem>
  )
}
